const ActiveCountries = ["AE", "KW", "SA", "OM", "BH", "QA", "UK", "GB", "US"];

export default ActiveCountries;
